import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import AuthLinks from './AuthLinks/AuthLinks';
import mastheadLogo from '../../assets/images/logo.svg';
import { RouterLink } from '../../components/Text/Text';
import Style from '../../styles/common';
import SearchBar from './SearchBar/SearchBar';

const Container = styled('div')`
  background-color: ${Style.color.MASTHEAD_BACKGROUND};
  border-bottom: 1px solid ${Style.color.MASTHEAD_BORDER};
  display: flex;
  height: ${Style.MEASUREMENT.MASTHEAD.HEIGHT}px;
  margin: 0;
  padding: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
`;

const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  padding: 0 ${Style.SPACING.L};
  width: ${Style.MEASUREMENT.PAGE.MAX_WIDTH};
`;

const LogoLink = styled(RouterLink)`
`;

const Logo = styled('img')`
  height: ${Style.MEASUREMENT.MASTHEAD.LOGO_HEIGHT};
`;

const Masthead = () => {
  return (
    <Container>
      <Wrapper>
        <LogoLink to={'/'}>
          <Logo src={mastheadLogo} aria-label="All These Events"/>
        </LogoLink>
        <SearchBar />
        <AuthLinks />
      </Wrapper>
    </Container>
  );
};

export default Masthead;



// WEBPACK FOOTER //
// ./src/views/Masthead/Masthead.js